import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import styles from './first-page.module.scss';

const FirstPage = () => {
  const navigate = useNavigate();

  const onClickStart = () => {
    navigate(`/video`);
  };

  return (
    <div className={styles.main}>
      <button
        onClick={() => onClickStart()}
        className={classNames(styles.btn, styles.primary, styles.button)}
      >
        Розпочати
      </button>
    </div>
  );
};

export { FirstPage };
